"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.observeAndShiftSiblings = void 0;
var observeAndShiftSiblings = exports.observeAndShiftSiblings = function observeAndShiftSiblings(inputElement) {
  var parentElement = inputElement === null || inputElement === void 0 ? void 0 : inputElement.parentElement;
  var labelElement = parentElement === null || parentElement === void 0 ? void 0 : parentElement.querySelector('label');
  if (inputElement && parentElement && labelElement) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          var siblings = [];
          var sibling = inputElement.nextSibling;
          while (sibling && sibling !== labelElement) {
            siblings.push(sibling);
            sibling = sibling.nextSibling;
          }
          siblings.forEach(function (sibling) {
            parentElement.insertBefore(sibling, labelElement.nextSibling);
          });
        }
      });
    });
    observer.observe(parentElement, {
      childList: true
    });
    return function () {
      observer.disconnect();
    };
  }
  return;
};